import { loadHoverImages, loadScaleImages } from '../image-effects';

export function oldLandingPage() {
	loadScaleImages();
	loadHoverImages();
}
